var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.995,
    height: 48,
    viewBox: "0 0 47.995 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FFFFFF;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.138,17.087a3.474,3.474,0,0,0-2.115-1.13v0L32.266,14.194,27.218,2.131a3.464,3.464,0,0,0-6.394,0L15.776,14.194,3.019,15.956a3.475,3.475,0,0,0-1.833,6.036L10.8,30.562,8.823,44.012a3.468,3.468,0,0,0,5.377,3.38l9.82-6.678,9.82,6.685a3.468,3.468,0,0,0,5.377-3.38L37.244,30.564l9.611-8.571A3.475,3.475,0,0,0,47.138,17.087ZM34.272,28.627a1.714,1.714,0,0,0-.554,1.529l2.057,14.4L24.99,37.222a1.714,1.714,0,0,0-1.927,0L12.214,44.511l2.11-14.361a1.714,1.714,0,0,0-.554-1.522L3.485,19.357l13.727-1.894a1.714,1.714,0,0,0,1.347-1.037l5.482-13a.077.077,0,0,1,.014.026l5.425,12.964a1.714,1.714,0,0,0,1.347,1.037l13.744,1.978Z",
    transform: "translate(-0.023 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.a2cb9361.svg";
export { ForwardRef as ReactComponent };